import React from "react";

import heroImg from "../../../assets/images/Dietplan-updated/ffc81ce5325de041bc8a948d5a6686d0f2f1b00f (1).png";

import "./ReportInsightsSection.css";

const ReportInsightsSection = () => {
  return (
    <div className="diet-report-insights">
      <div className="diet-report-insights__card" aria-label="Report insights highlight">
        <img className="diet-report-insights__image" src={heroImg} alt="Report insights preview" loading="lazy" />
      </div>

      <div className="diet-report-insights__below">
        <div className="diet-report-insights__belowTitle">Report Insights</div>
        <div className="diet-report-insights__belowText">
          Understand your progress with clear, detailed reports. Track trends across your body composition metrics,
          review changes over time, and use insights to stay consistent with your goals.
        </div>
      </div>
    </div>
  );
};

export default ReportInsightsSection;

